/**
 * Search Fimationality Hanslwea
 *
 * @author Industry at Delete
 * @see    https://github.com/industryatdelete
 */
jQuery(document).ready(function ($) {


    /*
     * Cache The Window Width.
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    var headerSearch = $('#header-search');


    /*
     * Cache The Window Width.
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    var form = $('#searchform');


    /*
     * Search Panel Dropdown Click Event Handler.
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $('.search-trigger').on('click', function (e) {
        var searchInput = headerSearch.find('.header-search-form input[type="search"]');
        headerSearch.toggleClass('is-hidden is-visible');
        if (form.hasClass('was-validated')) {
            form.trigger('reset').removeClass('was-validated');
            searchInput.val('');
        }
        // searchInput.focus();
    });


    /*
     * Clear Search Input Event Handler.
     *
     * Target this event with caution as this event is
     * a "non-standard" and only fired by Google Chrome.
     */
    $('input[type=search]').on('search', function (e) {
        //SkillsForWales.removeQueryParams(['s']);
    });

    /*
     * Validate Search Form On Submit.
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    form.on('submit', function (e) {
        if ($(this)[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            form.addClass('was-validated');
        }
    });


    /*
     * Inline searxh form field validation.
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $('#searchform').on('keyup input validate change', '.form-control', function (e) {
        var form = $(this).parent();
        var validity = form[0].checkValidity();
        if (validity === false) {
            form.addClass('was-validated');
        }
        return validity;
    });
});